import _ from 'lodash';

const consts = {
  ROUTES: {
    HOME: { NAME: 'home' },
    LEILAO: { NAME: 'leilao' },
    LEILOES: { NAME: 'leiloes' },
    LEILAO_LOTE: { NAME: 'leilao.lote' },
    CALENDARIO: { NAME: 'calendario' },
    ARTISTAS: { NAME: 'artistas' },
    EVENTOS: { NAME: 'eventos' },
    AUTH: { NAME: 'auth', PATH: '/auth' },
    AUTH_LOGIN: { NAME: 'auth.login', PATH: '/login' },
    AUTH_FORGOT_PASSWORD: { NAME: 'auth.forgotPassword', PATH: '/forgotPassword' },
    AUTH_RESET_PASSWORD: { NAME: 'auth.resetPassword', PATH: '/resetPassword' },
    AUTH_REGISTER: { NAME: 'auth.register', PATH: 'register' },
  },
  DATA_TABLE: {
    TYPES: {
      SELECT: 'select',
      MENU: 'menu',
      COMPONENT: 'component',
      TEXT: 'text',
    },
  },
  CALENDAR: {
    TYPES: {
      DAY: 'day',
      WEEK: 'week',
      MONTH: 'month',
    },
  },
  USER_ACTIONS: {
    LOGIN: 'Data/Auth/login',
    REGISTER: 'Data/Auth/register',
    VALIDATE_TOKEN: 'Data/Auth/validateToken',
    VALIDATE_EMAIL: 'Data/Auth/validateEmail',
    RESET_PASSWORD: 'Data/Auth/resetPassword',
    UPDATE_PASSWORD: 'Data/Auth/updatePassword',
    LOGOUT: 'Data/Auth/logout',
  },
  ENDPOINTS: {
    SOCKETIO: 'http://socketio.spitiart.localhost/',
    AUTH_LOGIN: `${window.DM_ENV.API_URL}/login`,
    AUTH_LOGOUT: `${window.DM_ENV.API_URL}/register`,
    REGISTER: `${window.DM_ENV.API_URL}/register`,
    AUTH_FORGOT_PASSWORD: `${window.DM_ENV.API_URL}/forgot-password`,
    AUTH_RESET_PASSWORD: `${window.DM_ENV.API_URL}/reset-password`,
    AUTH_EMAIL_VERIFICATION: `${window.DM_ENV.API_URL}/email/verification`,
    AUCTIONS_LIST: `${window.DM_ENV.API_URL}/auctions/list`,
    AUCTION_DETAILS: `${window.DM_ENV.API_URL}/auction/$1`,
    AUCTION_LOTS: `${window.DM_ENV.API_URL}/auction/$1/lots`,
    AUCTION_BIDS: `${window.DM_ENV.API_URL}/auction/$1/lot/$2/bids`,
    ARTISTS_LIST: `${window.DM_ENV.API_URL}/artists/list`,
    USER: `${window.DM_ENV.API_URL}/user`,
  },
};

_.forEach(consts, (item, idx) => {
  consts[idx] = Object.freeze(consts[idx]);
});

export default consts;
